import React from "react";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./DatePickerFilterBy.css";
import {
  CLEAR_LABEL,
  CREATED_LABEL,
  DATE_CREATED_FILTER_BY_LABEL,
  DATE_REVISED_FILTER_BY_LABEL,
  OK_LABEL,
  OR_LABEL,
  REVISED_LABEL,
} from "../../../utils/GlobalConstants";

const DatePickerFilterBy = ({
  createdDate,
  revisedDate,
  handleChangeDate,
  handleChangeRevisedDate,
  handleFetchSurveysWithFilter,
  handleClearDateForFilter,
  isDateCreatedClicked,
  isRevisedDateClicked,
}) => {
  return (
    <div className="date-picker-container">
      <div className="flex-for-center">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DateField", "DatePicker"]}>
            <DatePicker
              testid="datecreated"
              disabled={isRevisedDateClicked}
              label={DATE_CREATED_FILTER_BY_LABEL}
              disableFuture={true}
              value={dayjs(createdDate)}
              onChange={(newValue) => {
                handleChangeDate(newValue);
              }}
              slotProps={{
                textField: {
                  error: false,
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
      </div>
      <div className="flex-for-center">{OR_LABEL}</div>
      <div className="flex-for-center">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DateField", "DatePicker"]}>
            <DatePicker
              testid="daterevised"
              data-testid="Date Revised"
              disabled={isDateCreatedClicked}
              label={DATE_REVISED_FILTER_BY_LABEL}
              disableFuture={true}
              value={dayjs(revisedDate)}
              onChange={(newValue) => {
                handleChangeRevisedDate(newValue);
              }}
              slotProps={{
                textField: {
                  error: false,
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
      </div>
      <div className="ok-btn-center">
        <button
          testid="oklabel"
          className="button-style m-right"
          onClick={(e) => {
            e.preventDefault();
            handleFetchSurveysWithFilter(
              isDateCreatedClicked ? CREATED_LABEL : REVISED_LABEL
            );
          }}
        >
          {OK_LABEL}
        </button>
        <button
          testid="handle-clear-date"
          className="button-style"
          onClick={(e) => {
            e.preventDefault();
            handleClearDateForFilter();
          }}
        >
          {CLEAR_LABEL}
        </button>
      </div>
    </div>
  );
};

export default DatePickerFilterBy;
